import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { EesztAuthService } from '../../services/eeszt-auth.service';
import { FeedItem, FeedService } from '../../services/feed.service';

@Component({
  selector: 'app-eeszt-auth-dialog',
  imports: [
    CommonModule,
    DatePipe,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './eeszt-auth-dialog.html',
  styleUrl: './eeszt-auth-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EesztAuthDialog {
  private eesztAuthService = inject(EesztAuthService);
  private feedService = inject(FeedService);
  private dialogRef = inject(MatDialogRef<EesztAuthDialog>);

  loading = this.eesztAuthService.loading;
  feedItems = signal<FeedItem[]>([]);
  feedLoading = signal(true);

  constructor() {
    this.feedService.getItems().subscribe({
      next: items => this.feedItems.set(items.sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime())),
      complete: () => this.feedLoading.set(false),
      error: () => this.feedLoading.set(false)
    });
  }

  // Mobile token control
  motpControl = new FormControl('', Validators.required);

  // OTP form
  otpForm = new FormGroup({
    userName: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    otp: new FormControl('', Validators.required)
  });

  // Password visibility
  hidePassword = signal(true);

  authenticateWithEid(): void {
    this.eesztAuthService.authenticateWithEid().subscribe({
      complete: () => this.dialogRef.close(true)
    });
  }

  authenticateWithMobile(): void {
    if (this.motpControl.invalid) {
      this.motpControl.markAsTouched();
      return;
    }

    this.eesztAuthService.authenticateWithMobile(this.motpControl.value!).subscribe({
      complete: () => this.dialogRef.close(true)
    });
  }

  authenticateWithOtp(): void {
    if (this.otpForm.invalid) {
      this.otpForm.markAllAsTouched();
      return;
    }

    this.eesztAuthService.authenticateWithOtp({
      userName: this.otpForm.value.userName!,
      password: this.otpForm.value.password!,
      otp: this.otpForm.value.otp!
    }).subscribe({
      complete: () => this.dialogRef.close(true)
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }

  skipAuth(): void {
    this.dialogRef.close('skip');
  }
}
